app.service("RequestService", ['$rootScope', '$http', 'SiteHelper', function ($rootScope, $http, SiteHelper) {

    let didLogOut = false;
    const siteHelper = SiteHelper;
    const printRequest = true;


    this.getRequest = function (endpoint, callback) {
        $http.get(endpoint, {cache: false}).success(function (data) {
            if(printRequest){
                console.log("GET "+endpoint)
                console.log(JSON.parse(JSON.stringify(data)))
            }
            handleSuccess(data, callback);
        }).error(function (errorData, status) {
            if(printRequest){
                console.warn("GET "+endpoint)
            }

            handleError(dataFromErrorData(errorData), status, callback);
        });
    }

    this.postJsonRequest = function (endpoint, data, callback) {
        data = siteHelper.isObject(data) ? JSON.parse(JSON.stringify(data)) : {};
        for(let key in data){
            if(data[key] === null){
                delete data[key];
            }
        }
        if(!Object.keys(data).length){
            data = "";
        }

        $http({
            url: endpoint,
            method: "POST",
            data: data,
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                    if(printRequest){
                        console.log("POST "+endpoint)
                        console.log(JSON.parse(JSON.stringify(response)))
                    }
                    handleSuccess(response.data, callback);
                },
                function (errorData, status) { // optional
                    if(printRequest){
                        console.warn("POST "+endpoint)
                    }
                    handleError(dataFromErrorData(errorData), status, callback);
                });
    }

    this.postRequest = function (endpoint, data, callback,) {
        $http({
            url: endpoint,
            method: "POST",
            data: data
        })
            .then(function (response) {
                    if(printRequest){
                        console.log("POST (NJ) "+endpoint)
                        console.log(JSON.parse(JSON.stringify(response)))
                    }
                    let data = response.data;
                    if (data && !siteHelper.isObject(data)) {
                        data = {
                            message: data
                        }
                    }
                    handleSuccess(data, callback);
                },
                function (errorData) { // optional
                    if(printRequest){
                        console.warn("POST (NJ) "+endpoint)
                    }
                    handleError({message: errorData.data}, errorData.status, callback);
                });
    }

    this.deleteJsonRequest = function (endpoint, data, callback) {

        $http({
            url: endpoint,
            method: "DELETE",
            data: data,
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                    if(printRequest){
                        console.log("DELETE "+endpoint)
                        console.log(JSON.parse(JSON.stringify(response)))
                    }
                    handleSuccess(response.data, callback, true);
                },
                function (errorData, status) {
                    if(printRequest){
                        console.warn("DELETE "+endpoint)
                    }
                    handleError(dataFromErrorData(errorData), status, callback);
                });
    }

    this.deleteRequest = function (endpoint, data, callback) {

        $http({
            url: endpoint,
            method: "DELETE",
            data: data
        })
            .then(function (response) {
                    if(printRequest){
                        console.log("DELETE (NJ) "+endpoint)
                        console.log(JSON.parse(JSON.stringify(response)))
                    }
                    handleSuccess(response.data, callback, true);
                },
                function (errorData, status) {
                    if(printRequest){
                        console.warn("DELETE (NJ) "+endpoint)
                    }
                    handleError(dataFromErrorData(errorData), status, callback);
                });
    }


    this.uploadFileRequest = function (endpoint, data, callback) {

        $http({
            url: endpoint,
            method: "POST",
            data: data,

            headers: {
                "Content-Type": undefined
            }
        })
            .then(function (response) {
                    if(printRequest){
                        console.log("UPLOAD "+endpoint)
                        console.log(JSON.parse(JSON.stringify(response)))
                    }
                    handleSuccess(response.data, callback);
                },
                function (errorData, status) { // optional
                    if(printRequest){
                        console.warn("UPLOAD "+endpoint)
                    }
                    handleError(dataFromErrorData(errorData), status, callback);
                });
    }

    function handleSuccess(data, callback, allowEmpty) {
        if (didLogOut) {
            return;
        }
        if (data && typeof data !== 'object') {
            data = null;
        }

        if ((!data && !allowEmpty) || (data && data.error)) {
            callback(false, data, siteHelper.addErrorMessage((data ? data.message : null), null, null, true))
            return;
        }

        if (data && data.redirectlogin) {
            didLogOut = true;
            window.location = "/logout.php?login=1"
            return;
        }

        if (callback) {
            callback(true, data, [])
        }
    }

    function dataFromErrorData(errorData) {
        if (errorData && siteHelper.isObject(errorData) && errorData.data) {
            if(siteHelper.isObject(errorData.data)){
                return errorData.data;
            }
            return {
                message: errorData.data
            }
        }
        return null;
    }


    function handleError(data, status, callback) {
        if (didLogOut) {
            return;
        }

        if (callback) {
            let errors;
            if (data && siteHelper.isObject(data) && data.message) {
                errors = siteHelper.addErrorMessage(data.message)
            } else {
                errors = siteHelper.addErrorMessage("An error has occurred!", null, "defaultMessage");
            }
            callback(false, data, errors)
        }
    }

}]);